const palette = {
  background: {
    footer: '#F6F5F2'
  },
  grey: {
    main: '#3D3B40',
    light: '#EEEDEB',
    dark: '#31304D',
    contrastText: '#FFF'
  },
  hover: {
    options: 'lightblue'
  }
};

export default palette;
